const initSliderWidget = () => {
    const splides = document.querySelectorAll('.splide');
    // 1. query slider elements: are there any splide elements?
    if (splides.length) {
        // 2. process all instances
        for (let i = 0; i < splides.length; i++) {
            const splideElement = splides[i];
            //3.1 if no options are defined by 'data-splide' attribute: take these default options
            const splideDefaultOptions = {
                type: 'slide',
                rewind: true,
                perPage: 1,
                autoplay: false,
                arrows: true,
                pagination: true,
                drag: true,
                keyboard: true,
                heightRatio: 0.5,
                cover: true,
            };
            /**
            * 3.2 if options are defined by 'data-splide' attribute: default options will we overridden
            * see documentation: https://splidejs.com/guides/options/#by-data-attribute
            **/
            const splide = new Splide(splideElement, splideDefaultOptions);
            // 3. mount/initialize this slider
            splide.mount();
        }
    }
};
